export function getOwnerDocument(el) {
    return (el === null || el === void 0 ? void 0 : el.ownerDocument) || document;
}

//# sourceMappingURL=utils.js.map